import https from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const BASE_URL = 'forms/app/v1/flow-usages/form';
const _fetchFlowUsages = formGuid => https.get(`${BASE_URL}/${formGuid}`);
const getFlowUsagesKey = () => `FlowUsages`;
export const getFlowUsages = (formGuid = '') => getFromEarlyRequest(getFlowUsagesKey(), () => _fetchFlowUsages(formGuid));
export default getFlowUsages;